import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["groupsContainer", "totalDisplay"]

  connect() {
    this.updateTotal = this.updateTotal.bind(this)
    this.stripRequiredOnRemove = this.stripRequiredOnRemove.bind(this)
    this.$container = window.jQuery(this.groupsContainerTarget)
    this.$container.on("cocoon:after-insert", this.updateTotal)
    this.$container.on("cocoon:before-remove", this.stripRequiredOnRemove)
    this.$container.on("cocoon:after-remove", this.updateTotal)
    this.updateTotal()
  }

  disconnect() {
    if (this.$container) {
      this.$container.off("cocoon:after-insert", this.updateTotal)
      this.$container.off("cocoon:before-remove", this.stripRequiredOnRemove)
      this.$container.off("cocoon:after-remove", this.updateTotal)
    }
  }

  stripRequiredOnRemove(event, $element) {
    const removed = ($element && $element[0]) || event.target
    if (removed && removed.classList) {
      removed.classList.add("award-criteria-group-removed")
    }
    if (removed && removed.querySelectorAll) {
      removed.querySelectorAll("input[required]").forEach((input) => {
        input.removeAttribute("required")
      })
    }
    this.updateTotal()
  }

  updateTotal() {
    const inputs = this.groupsContainerTarget.querySelectorAll(".award-criteria-group-weighting")
    const sum = Array.from(inputs)
      .filter((input) => !this.isMarkedForDestruction(input))
      .reduce((acc, input) => acc + (parseInt(input.value, 10) || 0), 0)

    if (this.hasTotalDisplayTarget) {
      const el = this.totalDisplayTarget
      if (el.tagName === "INPUT") {
        el.value = sum
        const wrapper = el.closest(".form-group, .input-group")
        if (wrapper) wrapper.classList.toggle("has-error", sum !== 100)
      } else {
        const valueEl = el.querySelector(".award-criteria-groups-total-value")
        if (valueEl) valueEl.textContent = sum
        el.classList.toggle("label-success", sum === 100)
        el.classList.toggle("label-danger", sum !== 100)
        const iconEl = el.querySelector(".award-criteria-groups-total-icon")
        if (iconEl) {
          iconEl.classList.toggle("fa-check", sum === 100)
          iconEl.classList.toggle("fa-exclamation-circle", sum !== 100)
        }
      }
    }
  }

  isMarkedForDestruction(input) {
    const wrapper = input.closest(".award-criteria-group-fields")
    if (!wrapper) return false
    if (wrapper.classList.contains("award-criteria-group-removed")) return true
    if (wrapper.style.display === "none") return true
    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    return destroyInput && (destroyInput.value === "1" || destroyInput.value === "true")
  }
}
